

import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import VerifiedIcon from '@mui/icons-material/Verified';

const Thankyou = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="false" sx={{
            backgroundColor: "backgroundPrimary.main"
        }}>
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: {
                    xs: "180px",
                    sm: "200px",
                    lg: "300px",
                }
            }}>
                <Typography sx={{
                    fontSize: {
                        xs: "1.9rem",
                        sm: "2.5rem",
                        lg: "3.5rem",
                    },
                    color: {
                        xs: "#002865"
                    },
                    fontFamily: "Be vietnam Pro",
                    fontWeight: 400,
                    wordSpacing: "15px"
                }}>
                    Thank You
                </Typography>
                <Typography sx={{
                    fontSize: {
                        xs: "1.2rem",

                    },
                    color: {
                        xs: "drak"
                    },
                    fontFamily: "Be vietnam Pro",
                    fontWeight: 500,
                    wordSpacing: "3px"
                }}>
                    for shopping with us!
                </Typography>


                <Box sx={{
                    mt: 5,
                    background: "#023020",
                    width: 50,
                    height: 50,
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#FFF"
                }}>

                    <VerifiedIcon sx={{ fontSize: "30px" }} />
                </Box>

                <Typography sx={{
                    mt:1,
                    fontSize: {
                        xs: "2.5rem",

                    },
                    color: {
                        xs: "#008000"
                    },
                    fontFamily: "Onest",
                    fontWeight: 400,
                    wordSpacing: "3px"
                }}>
                    Order Success
                </Typography>


                <Button variant="contained" onClick={() => navigate('/')} sx={{ mt: { xs: 3, sm: 4, lg: 2 } }}>Back To Home</Button>

            </Box>
        </Container>
    )
}

export default Thankyou